export function pageHasRecord(page) {
  if (!page?.collection) return false;
  const url = page.url ?? '';
  return url.includes(':slug') || url.includes(':id');
}

export function matchPage(pages, path) {
  for (const page of pages ?? []) {
    if (!page.url) continue;

    if (!page.url.includes(':')) {
      if (page.url === path) return { page, recordId: null };
      continue;
    }

    const pattern = page.url.replace(/:(\w+)/g, '([^/]+)');
    const match = path.match(new RegExp(`^${pattern}$`));
    if (match) return { page, recordId: match[1] ?? null };
  }
  return null;
}
